import { defineComponent, inject } from 'vue';
import PasswordInputValidation from '../PasswordInputValidation/PasswordInputValidation.vue';
import PasswordInputClass from './PasswordInput.class';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { setupComponent } from "@studyportals/vue-platform";

export default defineComponent({
	props: {
		validation: Boolean,
		inputLabel: {
			type: String,
			default: 'Password',
		},
		autocompletePasswordType: String,
	},
	components: {
		PasswordInputValidation,
	},
	setup: (props) => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		if (!store) throw new Error('incentiveV2Store was not provided');
		const component = new PasswordInputClass(store, props.validation);
		return setupComponent(component);
	},
});
